import { render } from "./TommyPaperBarcode.vue?vue&type=template&id=265177cb"
import script from "./TommyPaperBarcode.vue?vue&type=script&lang=js"
export * from "./TommyPaperBarcode.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__